module.exports = {"220382001":"郑家屯街道","220382002":"辽西街道","220382003":"辽南街道","220382004":"辽北街道","220382005":"辽东街道","220382006":"红旗街道","220382100":"茂林镇","220382101":"双山镇","220382102":"卧虎镇","220382103":"服先镇","220382104":"王奔镇","220382105":"玻璃山镇","220382106":"兴隆镇","220382107":"东明镇","220382200":"那木乡","220382201":"柳条乡","220382202":"新立乡","220382203":"永加乡","220382400":"双辽农场（四平辽河农垦管理区）","220382401":"双辽种羊场（四平辽河农垦管理区）","220382402":"双辽经济开发区","220382403":"双辽鸭场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220382.json
// module id = 634
// module chunks = 0